import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getActiveUsersMembersForTaskUserSelector } from "~/store/selectors/selector.users.jsx";
import { AssigneePicker } from "./AssigneePicker/index.jsx";

export const ActiveMembersAssigneePicker = ({ position, hiddenFromClient, ...rest }) => {
  const options = useSelector(getActiveUsersMembersForTaskUserSelector);

  return (
    <AssigneePicker
      {...rest}
      options={options}
      position={position}
    />
  );
};

ActiveMembersAssigneePicker.propTypes = {
  position: PropTypes.string,
  hiddenFromClient: PropTypes.bool,
};
